import React from "react";
import DefaultQuestionBody from "./DefaultQuestionBody";

const NumberComponent = () => <DefaultQuestionBody />;

NumberComponent.information = {
	type: "number",
	name: "Number"
};

NumberComponent.extraSettings = {
	fractionSize: 0,
	numberFormat: ",.",
	numberType: "integer"
};

export default NumberComponent;
